import React from 'react';

function Hello(){
    return <h1>Hello World</h1>
}
export default Hello;